import {IconType} from '../components/parts/fe-icon/fe-icon.component';
import {SessionInterface} from '../interfaces/session/session.interface';
import {FEATURE_FLAGS} from './feature-flags';

/**
 * Présentation d'une fonctionnalité non incluse dans l'offre du client.
 * Source unique des textes : snackbar showFunctionDisabled() et modale des annonces.
 */
export interface FeaturePresentation {
  text: string;
  askContactTitle: string;
}

export const FEATURE_PRESENTATIONS: { [feature: string]: FeaturePresentation } = {
  monitoring: {
    text: 'La fonctionnalité "Suivi d\'affaires" vous permet de suivre les ' +
        'actions commerciales de vos équipes. Si vous souhaitez en savoir plus, ' +
        'merci de contacter votre chargé d\'affaires.',
    askContactTitle: 'Vous souhaitez des renseignements sur Suivi d\'affaires ?'
  },
  datAnalyz: {
    text: 'Base de données des entreprises françaises : recherchez et filtrez toutes les sociétés de votre ' +
        'territoire (activité, taille, chiffre d\'affaires, croissance…), visualisez-les sur une carte ' +
        'interactive, et analysez-les grâce aux statistiques et à la comparaison financière. Consultez leur ' +
        'fiche complète avec dirigeants, établissements et contacts enrichis, puis exportez vos cibles ou ' +
        'organisez-les en listes de prospection. Contactez votre chargé d\'affaires pour découvrir ce produit.',
    askContactTitle: 'Vous souhaitez des renseignements sur la Base de données des entreprises françaises ?'
  },
  dashboard: {
    text: 'Tableau de bord : visualisez en un coup d\'œil l\'activité de votre veille First ECO, avec la ' +
        'répartition des signaux d\'affaires par département, secteur et thématique, et leur évolution dans ' +
        'le temps. Filtrez par recherche enregistrée, retrouvez les entreprises citées et suivez l\'avancement ' +
        'de vos opportunités dans le Suivi d\'affaires. Contactez votre chargé d\'affaires pour découvrir ce produit.',
    askContactTitle: 'Vous souhaitez des renseignements sur le Tableau de bord ?'
  },
  decisions_admin: {
    text: 'Décisions administratives : un projet de construction ou d\'extension d\'entrepôt logistique ou de ' +
        'site industriel est toujours précédé d\'accords et de validations des autorités administratives (DREAL, ' +
        'MRAe, EPCI…), bien avant que l\'information soit publique. Cette option vous donne accès aux informations ' +
        'issues de ces sources institutionnelles pour détecter les projets dès leurs premières étapes, identifier ' +
        'plus tôt les acteurs concernés et anticiper les opportunités commerciales. Contactez votre chargé ' +
        'd\'affaires pour découvrir cette option.',
    askContactTitle: 'Vous souhaitez des renseignements sur les Décisions administratives ?'
  }
};

/**
 * Annonce de nouveauté affichée sous forme d'encart dans "Mes recherches" (FeAnnouncementCardComponent),
 * avec une modale de présentation (FeAnnouncementModalComponent).
 * Pour une nouvelle annonce : ajouter une présentation ci-dessus et une entrée ci-dessous.
 */
export interface ProductAnnouncement {
  // Identifiant stable : sert à mémoriser le masquage de l'encart
  id: string;
  // Clé de FEATURE_PRESENTATIONS : texte de la modale et fonctionnalité de la demande de contact
  feature: string;
  icon: IconType;
  title: string;
  shortText: string;
  modalTitle: string;
  headline: string;
  subtitle: string;
  timeline: { label: string, active?: boolean }[];
  // Condition d'affichage, évaluée sur la session du client
  isEligible: (session: SessionInterface) => boolean;
}

export const PRODUCT_ANNOUNCEMENTS: ProductAnnouncement[] = [
  {
    id: 'decisions_admin',
    feature: 'decisions_admin',
    icon: IconType.decision_admin,
    title: 'Nouveau : Décisions administratives',
    shortText: 'Détectez les projets de construction ou d\'extension dès les premières décisions des autorités ' +
        '(DREAL, MRAe, EPCI…).',
    modalTitle: 'Découvrez les Décisions administratives',
    headline: 'Repérez les projets avant qu\'ils ne deviennent publics',
    subtitle: 'Les autorités valident les projets bien avant leur annonce publique.',
    timeline: [
      {label: 'Décision administrative (DREAL, MRAe, EPCI…)', active: true},
      {label: 'Permis, enquête publique'}
    ],
    // Clients sans l'option "données institutionnelles" (=== false : pas d'affichage si l'information est absente)
    isEligible: session => FEATURE_FLAGS.decisionsAdmin
        && session.customerDetails?.hasInstitutionalData === false
        && session.productType !== 'Lettre_MotsCles'
  }
];
